import { FC } from 'react'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'

import { NavPillButton } from 'components/prize-draws/NavPillButton'

interface BackButtonProps {
  href: string
  label?: string
  ariaLabel?: string
  color?: string
  borderColor?: string
  compactOnMobile?: boolean
}

export const BackButton: FC<BackButtonProps> = ({
  href,
  label = 'Back',
  ariaLabel,
  color,
  borderColor,
  compactOnMobile,
}) => (
  <NavPillButton
    href={href}
    label={label}
    ariaLabel={ariaLabel}
    color={color}
    borderColor={borderColor}
    compactOnMobile={compactOnMobile}
    icon={<ArrowBackIosNewIcon sx={{ fontSize: '0.8rem !important' }} />}
  />
)
